import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  PunctualityIcon,
  EfficiencyIcon,
  SafetyComfortIcon,
  FlexibilityIcon,
  AirportPinIcon,
  PriceListIcon,
  PeopleSolidIcon,
  LuggageSolidIcon,
  ChargerSolidIcon,
  WifiSolidIcon,
  TvSolidIcon,
  DvdSolidIcon,
  ArrowRightIcon,
  ArrowDownIcon,
} from "../../../components/icons";

const alphard = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/alphard-new23.png";
const hiace_grand_cabin = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-grand-new23.png";
const hiace_luxury_cabin = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-new23.png";
const toyota_granace = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-new23.png";
const events = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/weddings-anniversaries-card.png";
const wedding = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/wedding-card.png";
const AirportTransfer = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/airport-transfer-card.png";
const business_transfer = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/executive-transfer-card.png";
const sightseeing = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/sightseeing-card.png";
const GolfTransfer = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/golf-transfer.png";
const EventPickUp = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/event-pick-up.png";
const Other = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/sightseeing.png";
const visa_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/visa-icon.svg";
const jcb_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/jcb-icon.svg";
const diners_club_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/diners-club-icon.svg";
const american_express_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/amex-icon.svg";
const discover_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/discover-icon.svg";
const maestro_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/maestro-icon.svg";
const Gads = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <FrontLayout>
      {/* <!-- hero --> */}
      <div className="hero-image-gads tw:flex tw:items-end">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none custom-pt-8 tw:mb-4 tw:pb-4 tw:md:pb-12">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:flex tw:flex-col tw:justify-end">
            <p className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-0 text-gold">{t("Corporate.Heading")}</p>
            <h1 className="tw:font-bold! tw:mb-6 tw:mt-2">{t("Gads.Main.Heading")}</h1>
            <p className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[58.3333%] tw:md:flex-none text-gold intro tw:mb-12 tw:lg:mb-0">{t("Gads.Main.Heading.Subheading")}</p>
          </div>
        </div>
      </div>
      {/* <!-- hero end --> */}
      {/* <!-- section 1, heading --> */}
      <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:mt-12 tw:lg:pt-12 tw:md:mb-4 tw:items-center">
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0 tw:mt-4 tw:lg:mt-0">
          <hr />
        </div>
        <div className="tw:px-[calc(var(--gx)/2)] tw:w-[83.3333%] tw:flex-none tw:sm:w-auto tw:sm:flex-none tw:text-center tw:mt-4 tw:lg:mt-0">
          <h3>{t("Gads.Heading.One")}</h3>
        </div>
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0 tw:mt-4 tw:lg:mt-0">
          <hr />
        </div>
      </div>
      {/* <!-- section 1, intro paragraph --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:lg:mt-4 tw:mb-0 tw:lg:mb-12 tw:md:pt-12 tw:mt-12 tw:sm:mt-0 tw:md:pb-2">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:mb-12 tw:gap-y-6 tw:items-center">
          <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:lg:w-[83.3333%] tw:lg:flex-none tw:lg:ml-[8.3333%]">

            <p className="tw:text-[#212529]!">{t("Gads.Intro")}</p>

          </div>
        </div>
      </div>
      {/* <!-- section 1 end --> */}
      {/* <!-- section 2, vehicle cards --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mx-0 tw:px-0 tw:pb-12">

        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:items-center tw:mb-12 tw:lg:mb-0">
          <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
            <hr />
          </div>
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:text-center">
            <h3>{t("Fleet.Heading")}</h3>
          </div>
          <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
            <hr />
          </div>
        </div>

        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-4 tw:mt-6 tw:lg:mt-4 tw:lg:pt-12 tw:pb-4">

          <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:gap-y-6 tw:[--gx:0.5rem]">

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none card-hover-btop">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] custom-card tw:h-full shadow-sm-2">
                <img
                  src={alphard}
                  className="tw:w-full tw:rounded-t-[0.3rem] custom-border-top tw:px-6 hovered-card tw:h-full"
                  alt="Toyota Alphard"
                />

                <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                  {t("Toyota.Alphard.Tag")}
                </div>
                <div className="tw:flex-1 tw:p-4 tw:pt-1">
                  <h5 className="tw:mb-2 tw:mb-4">
                    {t("Toyota.Alphard")}
                  </h5>
                </div>
                <div className="tw:flex-1 tw:p-4 bg-light-grey tw:flex tw:flex-col tw:pt-1">


                  {/* <!-- icons --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:*:w-full tw:*:flex-none tw:gap-y-2 bg-light-grey tw:my-4">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <PeopleSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Alphard.Passengers")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <LuggageSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Alphard.Suitcases")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">

                        <ChargerSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Alphard.Mobile.Device.Charger")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">

                        <WifiSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Alphard.Wifi")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">

                        <TvSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Alphard.Television")}
                        </p>
                      </div>
                    </div>

                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <DvdSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Alphard.DVD.Player")}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- icons end --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                      <div className="tw:grid tw:gap-2">
                        <button
                          onClick={() => history.push("./alphard")}
                          type="button"
                          className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                        >
                          <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                            {t("Learn.More")}
                            <i className="tw:pl-2">
                              <ArrowRightIcon color="#4A4A4A" size={24} />
                            </i>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none card-hover-btop">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] custom-card tw:h-full shadow-sm-2">
                <img
                  src={toyota_granace}
                  className="tw:w-full tw:rounded-t-[0.3rem] custom-border-top tw:px-6 hovered-card tw:h-full"
                  alt="Toyota GranAce"
                />

                <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                  {t("Toyota.Granace.Tag")}
                </div>
                <div className="tw:flex-1 tw:p-4 tw:pt-1">
                  <h5 className="tw:mb-2 tw:mb-4">
                    {t("Toyota.Granace")}
                  </h5>
                </div>
                <div className="tw:flex-1 tw:p-4 bg-light-grey tw:flex tw:flex-col tw:pt-1">


                  {/* <!-- icons --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:*:w-full tw:*:flex-none tw:gap-y-2 bg-light-grey tw:my-4">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <PeopleSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Granace.Passengers")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <LuggageSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Granace.Suitcases")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <ChargerSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Granace.Mobile.Device.Charger")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <WifiSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Granace.Wifi")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <TvSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Granace.Television")}
                        </p>
                      </div>
                    </div>

                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <DvdSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Granace.DVD.Player")}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- icons end --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                      <div className="tw:grid tw:gap-2">
                        <button
                          onClick={() => history.push("./granace")}
                          type="button"
                          className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                        >
                          <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                            {t("Learn.More")}
                            <i className="tw:pl-2">
                              <ArrowRightIcon color="#4A4A4A" size={24} />
                            </i>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none card-hover-btop">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] custom-card tw:h-full shadow-sm-2">
                <img
                  src={hiace_grand_cabin}
                  className="tw:w-full tw:rounded-t-[0.3rem] custom-border-top tw:px-6 hovered-card tw:h-full"
                  alt="Toyota HiAce Grand Cabin"
                />

                <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                  {t("Toyota.Hiace.Tag")}
                </div>
                <div className="tw:flex-1 tw:p-4 tw:pt-1">
                  <h5 className="tw:mb-2 tw:mb-4">
                    {t("Toyota.HiAce.Grand.Cabin")}
                  </h5>
                </div>
                <div className="tw:flex-1 tw:p-4 bg-light-grey tw:flex tw:flex-col tw:pt-1">


                  {/* <!-- icons --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:*:w-full tw:*:flex-none tw:gap-y-2 bg-light-grey tw:my-4">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <PeopleSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Passengers")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <LuggageSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Suitcases")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <ChargerSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Mobile.Device.Charger")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <WifiSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Wifi")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <TvSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Television")}
                        </p>
                      </div>
                    </div>

                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <DvdSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.DVD.Player")}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- icons end --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                      <div className="tw:grid tw:gap-2">
                        <button
                          onClick={() => history.push("./hiace-grand-cabin")}
                          type="button"
                          className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                        >
                          <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                            {t("Learn.More")}
                            <i className="tw:pl-2">
                              <ArrowRightIcon color="#4A4A4A" size={24} />
                            </i>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none card-hover-btop">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] custom-card border-grey tw:h-full shadow-sm-2">
                <img
                  src={hiace_luxury_cabin}
                  className="tw:w-full tw:rounded-t-[0.3rem] custom-border-top tw:px-6 hovered-card tw:h-full"
                  alt="Toyota HiAce Luxury Cabin"
                />

                <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                  {t("Toyota.Hiace.Luxury.Tag")}
                </div>
                <div className="tw:flex-1 tw:p-4 tw:pt-1">
                  <h5 className="tw:mb-2 tw:mb-4">
                    {t("Toyota.Hiace.Luxury")}
                  </h5>
                </div>
                <div className="tw:flex-1 tw:p-4 bg-light-grey tw:flex tw:flex-col tw:pt-1">
                  {/* <!-- icons --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:*:w-full tw:*:flex-none tw:gap-y-2 bg-light-grey tw:my-4">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <PeopleSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Luxury.Passengers")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <LuggageSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Luxury.Suitcases")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <ChargerSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Luxury.Mobile.Device.Charger")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <WifiSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Luxury.Wifi")}
                        </p>
                      </div>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <TvSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Luxury.Television")}
                        </p>
                      </div>
                    </div>

                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-row">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:mr-2 tw:flex tw:self-center">
                        <DvdSolidIcon className="vehicle-specs-icons tw:h-auto" />
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pl-0">
                        <p className="tw:mb-0">
                          {t("Toyota.Hiace.Luxury.DVD.Player")}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- icons end --> */}
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                      <div className="tw:grid tw:gap-2">
                        <button
                          onClick={() => history.push("./hiace-luxury-cabin")}
                          type="button"
                          className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                        >
                          <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                            {t("Learn.More")}
                            <i className="tw:pl-2">
                              <ArrowRightIcon color="#4A4A4A" size={24} />
                            </i>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* <!-- section 2, vehicle cards, end --> */}
      {/* <!-- section 3, banner --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:mt-12 tw:pt-12 tw:md:pt-0 cta-banner-alphard">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-12 tw:pt-12 tw:md:pt-0">

          <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:pt-12 tw:md:py-4">
            <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:md:w-2/3 tw:md:flex-none tw:lg:w-[58.3333%] tw:lg:flex-none tw:py-6 tw:my-6 tw:flex tw:flex-col tw:justify-center">

              <div className="tw:mb-2 tw:mt-12 tw:md:mt-0 tw:px-[calc(var(--gx)/2)] tw:lg:w-2/3 tw:lg:flex-none">
                <h4 className="card-title-banner">{t("CTA.Banner.Vehicle.Heading")}</h4>
              </div>

              <p className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-2/3 tw:lg:flex-none intro tw:mb-6">{t("CTA.Banner.Vehicle.Intro")}</p>

              <div className="tw:grid tw:gap-2 tw:md:block tw:mt-auto">
                <button
                  onClick={() => history.push("./book")}
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:text-[1.25rem] tw:rounded-[0.5rem] tw:py-2 tw:px-4 tw:px-12 tw:md:mr-2"
                >
                  <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                    {t("Book.Your.Journey")}
                    <i className="tw:pl-2">
                      <ArrowRightIcon color="#4A4A4A" size={24} />
                    </i>
                  </div>
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
      {/* <!-- section 3, banner, end --> */}
      {/* <!-- section 4, services, img --> */}
      <div className="hero-image-private-tour tw:flex tw:items-end">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none custom-pt-8 tw:mb-4 tw:pb-4 tw:md:pb-12">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:flex tw:flex-col tw:justify-end">
            <p className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-0 text-gold">{t("Services")}</p>
            <h1 className="tw:font-bold! tw:mb-6 tw:mt-2">{t("Services")}</h1>
            <p className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[58.3333%] tw:md:flex-none text-gold intro tw:mb-12 tw:lg:mb-0">{t("Index.Heading.Two")}</p>
          </div>
        </div>
      </div>
      {/* <!-- section 4 packages--> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mx-0 tw:px-0 custom-mt-7 tw:py-12">

        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mx-0 tw:px-0 bg-light-grey tw:pb-4">
          <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-12 tw:mt-12 tw:py-12 bg-light-grey">

            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:gap-y-6 tw:-mt-2">

              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none">
                <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] h-custom-2 custom-card tw:h-full shadow-sm-2">
                  <img
                    src={AirportTransfer}
                    className="tw:w-full tw:rounded-t-[0.3rem] custom-border-bottom card-image-custom-h"
                    alt="Airport transfer service"
                  />

                  <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                    {t("Index.Card.Five.Tag")}
                  </div>
                  <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:pt-1">
                    <h5 className="tw:mb-2 tw:mb-4">
                      {t("Index.Card.Five.Heading")}
                    </h5>

                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                        <div className="tw:grid tw:gap-2">
                          <button
                            onClick={() => history.push("./airport-transfer")}
                            type="button"
                            className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                          >
                            <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                              {t("Book.Now")}
                              <i className="tw:pl-2">
                                <ArrowRightIcon color="#4A4A4A" size={24} />
                              </i>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none">
                <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] h-custom-2 custom-card tw:h-full shadow-sm-2">
                  <img
                    src={events}
                    className="tw:w-full tw:rounded-t-[0.3rem] custom-border-bottom card-image-custom-h"
                    alt="Events, such as weddings and anniversaries"
                  />

                  <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                    {t("Index.Card.Six.Tag")}
                  </div>
                  <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:pt-1">
                    <h5 className="tw:mb-2 tw:mb-4">
                      {t("Index.Card.Six.Heading")}
                    </h5>

                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                        <div className="tw:grid tw:gap-2">
                          <button
                            onClick={() =>
                              history.push("./weddings-anniversaries")
                            }
                            type="button"
                            className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                          >
                            <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                              {t("Book.Now")}
                              <i className="tw:pl-2"><ArrowRightIcon color="#4A4A4A" size={24} />
                              </i>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none">
                <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] h-custom-2 custom-card tw:h-full shadow-sm-2">
                  <img
                    src={business_transfer}
                    className="tw:w-full tw:rounded-t-[0.3rem] custom-border-bottom card-image-custom-h"
                    alt="Business transfer"
                  />

                  <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                    {t("Index.Card.Seven.Tag")}
                  </div>
                  <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:pt-1">
                    <h5 className="tw:mb-2 tw:mb-4">
                      {t("Index.Card.Seven.Heading")}
                    </h5>

                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                        <div className="tw:grid tw:gap-2">
                          <button
                            onClick={() => history.push("./executive-transfer")}
                            type="button"
                            className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                          >
                            <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                              {t("Book.Now")}
                              <i className="tw:pl-2"><ArrowRightIcon color="#4A4A4A" size={24} />
                              </i>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:xl:w-1/4 tw:xl:flex-none">
                <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] h-custom-2 custom-card tw:h-full shadow-sm-2">
                  <img
                    src={sightseeing}
                    className="tw:w-full tw:rounded-t-[0.3rem] custom-border-bottom card-image-custom-h"
                    alt="Sightseeing: private tours and packages"
                  />

                  <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-4 tw:pt-4 tw:pb-2">
                    {t("Index.Card.Eight.Tag")}
                  </div>
                  <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:pt-1">
                    <h5 className="tw:mb-2 tw:mb-4">
                      {t("Index.Card.Eight.Heading")}
                    </h5>

                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-auto">

                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                        <div className="tw:grid tw:gap-2">
                          <button
                            onClick={() => history.push("./private-tour")}
                            type="button"
                            className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                          >
                            <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                              {t("Book.Now")}
                              <i className="tw:pl-2"><ArrowRightIcon color="#4A4A4A" size={24} />
                              </i>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- section 2, 2 card grid highlighted packages --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mx-0 tw:px-0 tw:mt-4">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-4 tw:pb-6">
          <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:gap-y-6">

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-full tw:sm:flex-none tw:md:w-full tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:border-0 tw:px-0">
                <div className="hnd-banner">
                  <div className="tw:flex-1 tw:p-4 tw:ml-4 tw:py-0">

                    <div className="tw:flex tw:flex-row tw:py-4">

                      {/* <!-- icon and hnd --> */}
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:flex tw:flex-col tw:justify-between">

                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:pt-4">
                          <AirportPinIcon
                            className="tw:max-w-full tw:h-auto"
                            aria-label="Airport icon"
                            role="img"
                          />
                        </div>
                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:text-center tw:pt-4 tw:pb-4 tw:mb-0">
                          <p className="tw:mb-0">HND</p>
                        </div>

                      </div>

                      {/* <!-- vertical line --> */}
                      <div className="tw:w-auto tw:flex-none tw:flex tw:items-center tw:px-6">
                        <div className="vl"></div>
                      </div>

                      {/* heading and button --> */}
                      <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-col tw:justify-between">

                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                          <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pt-4 tw:pl-0 tw:pb-2">
                            {t("Index.Card.Five.Tag")}
                          </div>
                          <h5 className="tw:mb-2 card-title-banner">
                            {t("Haneda.Airport")}
                          </h5>
                        </div>

                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/2 tw:md:flex-none tw:flex tw:flex-col tw:justify-self-end tw:pb-4">
                          <div className="tw:grid tw:gap-2">
                            <button
                              onClick={() => history.push("./haneda-airport-transfer")}
                              type="button"
                              className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                            >
                              <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                                {t("Book.Now")}
                                <i className="tw:pl-2"><ArrowRightIcon color="#4A4A4A" size={24} />
                                </i>
                              </div>
                            </button>
                          </div>
                        </div>

                      </div>



                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-full tw:sm:flex-none tw:md:w-full tw:md:flex-none tw:lg:w-1/2 tw:lg:flex-none">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:border-0 tw:px-0">
                <div className="nrt-banner">
                  <div className="tw:flex-1 tw:p-4 tw:ml-4 tw:py-0">

                    <div className="tw:flex tw:flex-row tw:py-4">

                      {/* <!-- icon and hnd --> */}
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:flex tw:flex-col tw:justify-between">

                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:pt-4">
                          <AirportPinIcon
                            className="tw:max-w-full tw:h-auto"
                            aria-label="Airport icon"
                            role="img"
                          />
                        </div>
                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:text-center tw:pt-4 tw:pb-4 tw:mb-0">
                          <p className="tw:mb-0">NRT</p>
                        </div>

                      </div>

                      {/* <!-- vertical line --> */}
                      <div className="tw:w-auto tw:flex-none tw:flex tw:items-center tw:px-6">
                        <div className="vl"></div>
                      </div>

                      {/* heading and button --> */}
                      <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:flex tw:flex-col tw:justify-between">

                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                          <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pt-4 tw:pl-0 tw:pb-2">
                            {t("Index.Card.Five.Tag")}
                          </div>
                          <h5 className="tw:mb-2 card-title-banner">
                            {t("Narita.Airport")}
                          </h5>
                        </div>

                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/2 tw:md:flex-none tw:flex tw:flex-col tw:justify-self-end tw:pb-4">
                          <div className="tw:grid tw:gap-2">
                            <button
                              onClick={() => history.push("./narita-airport-transfer")}
                              type="button"
                              className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1"
                            >
                              <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                                {t("Book.Now")}
                                <i className="tw:pl-2"><ArrowRightIcon color="#4A4A4A" size={24} />
                                </i>
                              </div>
                            </button>
                          </div>
                        </div>

                      </div>



                    </div>

                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      {/* <!-- section 4, 2 card grid end -->
      {/* <!-- section 4, end -->
      {/* <!-- section 5, use case, heading --> */}
      <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:mt-12 tw:lg:pt-12 tw:mb-4 tw:md:mb-12 tw:items-center">
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
        <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:text-center">
          <h3>{t("Customer.Use.Cases.Heading")}</h3>
        </div>
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
      </div>
      {/* <!-- section 5, use case, heading, end --> */}
      {/* <!-- section 5, use case, cards --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mx-0 tw:px-0 tw:mb-4 tw:lg:mb-12 tw:lg:pt-12 tw:pb-12">

        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-4">
          <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:gap-y-6 tw:[--gx:0.5rem] tw:-mb-1 tw:items-stretch">

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full h-custom-1 tw:shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.075)]">
                <img
                  src={wedding}
                  className="tw:w-full img-cover"
                  alt="Customer use case: events and special occasions"
                />
                <div className="tw:absolute tw:inset-0 tw:p-4 tw:rounded-[calc(0.3rem-1px)] card-gradient tw:flex tw:flex-col card-content-height-2">

                  <hr className="card-line" />
                  <h5 className="tw:mb-2 tw:mb-4">{t("Gads.Customer.Use.Case.One.Heading")}</h5>

                  <p className="">{t("Gads.Customer.Use.Case.One.Description")}</p>


                </div>
              </div>
            </div>

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full h-custom-1 tw:shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.075)]">
                <img
                  src={GolfTransfer}
                  className="tw:w-full img-cover"
                  alt="Customer use case: golf transfer"
                />
                <div className="tw:absolute tw:inset-0 tw:p-4 tw:rounded-[calc(0.3rem-1px)] card-gradient tw:flex tw:flex-col card-content-height-2">

                  <hr className="card-line" />
                  <h5 className="tw:mb-2 tw:mb-4">{t("Gads.Customer.Use.Case.Two.Heading")}</h5>
                  <p className="tw:mb-0">{t("Gads.Customer.Use.Case.Two.Description")}</p>

                </div>
              </div>
            </div>

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full h-custom-1 tw:shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.075)]">
                <img
                  src={EventPickUp}
                  className="tw:w-full img-cover"
                  alt="Customer use case: event transfer/ pick-up"
                />
                <div className="tw:absolute tw:inset-0 tw:p-4 tw:rounded-[calc(0.3rem-1px)] card-gradient tw:flex tw:flex-col card-content-height-2">

                  <hr className="card-line" />
                  <h5 className="tw:mb-2 tw:mb-4">{t("Gads.Customer.Use.Case.Three.Heading")}</h5>
                  <p className="tw:mb-0">{t("Gads.Customer.Use.Case.Three.Description")}</p>

                </div>
              </div>
            </div>

            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-1/2 tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full h-custom-1 tw:shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.075)]">
                <img
                  src={Other}
                  className="tw:w-full img-cover"
                  alt="Customer use case: luxury private tours in Japan"
                />
                <div className="tw:absolute tw:inset-0 tw:p-4 tw:rounded-[calc(0.3rem-1px)] card-gradient tw:flex tw:flex-col card-content-height-2">

                  <hr className="card-line" />
                  <h5 className="tw:mb-2 tw:mb-4">{t("Gads.Customer.Use.Case.Four.Heading")}</h5>
                  <p className="tw:mb-0">{t("Gads.Customer.Use.Case.Four.Description")}</p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- section 5, cards, end --> */}
      {/* <!-- section 6, why us, heading --> */}
      <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 custom-pt-8 tw:md:mb-4 tw:items-center">
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
        <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:text-center">
          <h3>{t("WeddingsAnniversaries.Heading.Two")}</h3>
        </div>
        <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
          <hr />
        </div>
      </div>
      {/* <!-- section 6, why us cards --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-4 tw:lg:mt-6 tw:md:mb-12 tw:py-12">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:gap-y-6">

          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-full tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
            <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] why-us-card tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:md:w-1/4 tw:md:flex-none tw:lg:w-auto tw:lg:flex-none tw:flex tw:items-center">
                      <PunctualityIcon className="tw:w-full tw:h-auto" aria-label="Punctuality" role="img" />
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:lg:grow tw:lg:w-auto tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5 className="tw:mb-2 tw:text-[1.25rem]! tw:mb-0">{t("WeddingsAnniversaries.Heading.Two.Card.One")}</h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p className="tw:mb-0 tw:pt-4">
                    {t("WeddingsAnniversaries.Heading.Two.Card.One.Description")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-full tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
            <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] why-us-card tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:md:w-1/4 tw:md:flex-none tw:lg:w-auto tw:lg:flex-none tw:flex tw:items-center">
                      <EfficiencyIcon className="tw:w-full tw:h-auto" aria-label="Efficiency" role="img" />
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:lg:grow tw:lg:w-auto tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5 className="tw:mb-2 tw:text-[1.25rem]! tw:mb-0">{t("WeddingsAnniversaries.Heading.Two.Card.Two")}</h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p className="tw:mb-0 tw:pt-4">
                    {t("WeddingsAnniversaries.Heading.Two.Card.Two.Description")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-full tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
            <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] why-us-card tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:md:w-1/4 tw:md:flex-none tw:lg:w-auto tw:lg:flex-none tw:flex tw:items-center">
                      <SafetyComfortIcon className="tw:w-full tw:h-auto" aria-label="Safety and comfort" role="img" />
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:lg:grow tw:lg:w-auto tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5 className="tw:mb-2 tw:text-[1.25rem]! tw:mb-0">{t("WeddingsAnniversaries.Heading.Two.Card.Three")}</h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p className="tw:mb-0 tw:pt-4">
                    {t("WeddingsAnniversaries.Heading.Two.Card.Three.Description")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:sm:w-full tw:sm:flex-none tw:md:w-1/2 tw:md:flex-none tw:lg:w-1/4 tw:lg:flex-none">
            <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] why-us-card tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:md:w-1/4 tw:md:flex-none tw:lg:w-auto tw:lg:flex-none tw:flex tw:items-center">
                      <FlexibilityIcon className="tw:w-full tw:h-auto" aria-label="Flexibility" role="img" />
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:lg:grow tw:lg:w-auto tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5 className="tw:mb-2 tw:text-[1.25rem]! tw:mb-0">{t("WeddingsAnniversaries.Heading.Two.Card.Four")}</h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p className="tw:mb-0 tw:pt-4">
                    {t("WeddingsAnniversaries.Heading.Two.Card.Four.Description")}
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      {/* <!-- section 6, why us, end --> */}
      {/* <!-- section 7, banner --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:mt-12 tw:pt-12 tw:md:pt-0 cta-banner-alphard">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-12 tw:pt-12 tw:md:pt-0">

          <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:pt-12 tw:md:py-4">
            <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:md:w-2/3 tw:md:flex-none tw:lg:w-[58.3333%] tw:lg:flex-none tw:py-6 tw:my-6 tw:flex tw:flex-col tw:justify-center">

              <div className="tw:mb-2 tw:mt-12 tw:md:mt-0 tw:px-[calc(var(--gx)/2)] tw:lg:w-2/3 tw:lg:flex-none">
                <h4 className="card-title-banner">{t("CTA.Banner.Vehicle.Heading")}</h4>
              </div>

              <p className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-2/3 tw:lg:flex-none intro tw:mb-6">{t("CTA.Banner.Vehicle.Intro")}</p>

              <div className="tw:grid tw:gap-2 tw:md:block tw:mt-auto">
                <button
                  onClick={() => history.push("./book")}
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:text-[1.25rem] tw:rounded-[0.5rem] tw:py-2 tw:px-4 tw:px-12 tw:md:mr-2"
                >
                  <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                    {t("Book.Your.Journey")}
                    <i className="tw:pl-2"><ArrowRightIcon color="#4A4A4A" size={24} />
                    </i>
                  </div>
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
      {/* <!-- section 7, banner, end --> */}
      {/* <!-- section 8, pricing / 料金表, img --> */}
      <div className="hero-image-pricing tw:flex tw:items-end">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none custom-pt-8 tw:mb-4 tw:pb-4 tw:md:pb-12">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:flex tw:flex-col tw:justify-end">
            <p className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-0 text-gold">{t("Pricing")}</p>
            <h1 className="tw:font-bold! tw:mb-6 tw:mt-2">{t("Pricing")}</h1>
            <p className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[58.3333%] tw:md:flex-none text-gold intro tw:mb-12 tw:lg:mb-0">
              {t("Pricing.Intro")} &nbsp;<span>
                <Link className={``} to="./contact">{t("Pricing.Intro.Link")}</Link>
              </span>&nbsp; {t("Pricing.Intro.Part.Two")} <span><a href="mailto:info@theluxuryfleet.com">{/* <!-- hello --> */} in{/* <!-- @tlf --> */}fo@thelux{/* <!-- urious.co --> */}uryfleet.c{/* <!-- m --> */}om</a></span></p>
          </div>
        </div>
      </div>
      {/* <!-- section 8, pricing, download btns --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-12 tw:pt-12 tw:lg:mt-12 tw:lg:w-2/3 tw:lg:flex-none tw:lg:ml-[16.6667%]">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:md:mb-4 tw:lg:mb-2 tw:justify-center">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/4 tw:flex-none tw:mb-12 tw:flex tw:justify-center">
            <PriceListIcon
              className="tw:px-6"
              aria-label="Price list icon"
              role="img"
            />
          </div>
          <h4 className="tw:text-center tw:mb-4">{t("Full.Price.List")}</h4>
          <p className="tw:text-center">{t("Pricing.Select")}</p>
        </div>
        {/* <!-- section 1, download btns --> */}
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:lg:mb-12 tw:justify-center">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/2 tw:md:flex-none">
            <div className="tw:grid tw:gap-2 tw:block tw:mt-auto">
              <a
                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1 tw:mt-4 tw:mb-0"
                target="_blank"
                href="https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/pricing/TLF-Pricelist-EN.pdf" rel="noreferrer"
              >
                <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                  Download price list
                  <i className="tw:flex tw:self-center tw:pl-2"><ArrowDownIcon /></i>
                </div>
              </a>
            </div>
          </div>
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/2 tw:md:flex-none">
            <div className="tw:grid tw:gap-2 tw:block tw:mt-auto">
              <a
                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-white tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:text-sm tw:py-1 tw:px-2 tw:text-[#212529]! tw:px-1 tw:mt-4 tw:mb-0"
                target="_blank"
                href="https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/pricing/TLF-Pricelist-JP.pdf" rel="noreferrer"
              >
                <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                  価格表をダウンロードする
                  <i className="tw:flex tw:self-center tw:pl-2"><ArrowDownIcon /></i>
                </div>
              </a>
            </div>
          </div>
        </div>

      </div>
      {/* <!-- section 8, download btns, end --> */}
      {/* <!-- section 8, payment methods --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-12 tw:pt-12 tw:lg:w-1/2 tw:lg:flex-none tw:lg:ml-[25%]">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:justify-center">
          <h4 className="tw:text-center tw:mb-6">{t("Pricing.Heading.Two")}</h4>
          <p className="tw:text-center">{t("Pricing.Heading.Two.Paragraph.One")}</p>
        </div>
        {/* <!-- section 8, payment methods icons --> */}
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:px-4 tw:md:px-0">
          <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:lg:w-full tw:lg:flex-none tw:flex-col tw:mx-auto tw:p-0">

            <div className="tw:border-0 tw:mb-2 tw:flex tw:flex-row tw:items-center tw:justify-center tw:gap-4" >
              <img src={visa_icon} alt="" srcSet="" />
              <img src={jcb_icon} alt="" srcSet="" />
              <img src={diners_club_icon} alt="" srcSet="" />
              <img src={american_express_icon} alt="" srcSet="" />
              <img src={discover_icon} alt="" srcSet="" />
              <img src={maestro_icon} alt="" srcSet="" />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- section 8, terms --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-0 tw:pt-4 tw:lg:pt-12 tw:mt-12 tw:mb-4">
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:mb-12 tw:items-center">
          <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
            <hr />
          </div>
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:text-center">
            <h3>{t("Pricing.Heading.Three")}</h3>
          </div>
          <div className="tw:flex-1 tw:basis-0 tw:grow tw:px-0">
            <hr />
          </div>
        </div>
      </div>

      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-[58.3333%] tw:lg:flex-none tw:pb-4 tw:px-4 tw:md:px-0">

        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:lg:mb-12">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
            <h5 className="tw:mb-6 tw:md:mb-0">{t("Pricing.Heading.Three.Subheading.One")}</h5>
          </div>
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-3/4 tw:md:flex-none">
            <p>{t("Pricing.Heading.Three.Subheading.One.Paragraph.One")}</p>
            <ul>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.One.Paragraph.Two")} </li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.One.Paragraph.Three")} </li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.One.Paragraph.Four")}</li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.One.Paragraph.Five")}</li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.One.Paragraph.Six")}</li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.One.Paragraph.Seven")}</li>
            </ul>
          </div>
        </div>
        <hr className="card-line-light-grey"></hr>

        {/* <!-- section 1, airport transfer terms --> */}
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:lg:mb-12 tw:pt-4 tw:md:mt-12 tw:md:pt-0">
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:md:w-1/4 tw:md:flex-none">
            <h5 className="tw:mb-6 tw:md:mb-0">{t("Pricing.Heading.Three.Subheading.Two")}</h5>
          </div>
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-3/4 tw:md:flex-none">
            <p>{t("Pricing.Heading.Three.Subheading.Two.Paragraph.One")}</p>
            <ul>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.Two.Paragraph.Two")} </li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.Two.Paragraph.Three")} </li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.Two.Paragraph.Four")}</li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.Two.Paragraph.Five")}</li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.Two.Paragraph.Six")}</li>
              <li className="tw:my-1">{t("Pricing.Heading.Three.Subheading.Two.Paragraph.Seven")} &nbsp;
                <span><Link className={``}
                  to="./pricing">
                  {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Seven.Link")}
                </Link></span>&nbsp; {t("Pricing.Heading.Three.Subheading.Two.Paragraph.Seven.Part.Two")}
              </li>

            </ul>
          </div>
        </div>


      </div>
      {/* <!-- section 9, banner --> */}
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:mt-12 tw:pt-12 tw:md:pt-0 cta-banner-alphard">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-12 tw:pt-12 tw:md:pt-0">

          <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-0 tw:pt-12 tw:md:py-4">
            <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:md:w-2/3 tw:md:flex-none tw:lg:w-[58.3333%] tw:lg:flex-none tw:py-6 tw:my-6 tw:flex tw:flex-col tw:justify-center">

              <div className="tw:mb-2 tw:mt-12 tw:md:mt-0 tw:px-[calc(var(--gx)/2)] tw:lg:w-2/3 tw:lg:flex-none">
                <h4 className="card-title-banner">{t("CTA.Banner.Vehicle.Heading")}</h4>
              </div>

              <p className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-2/3 tw:lg:flex-none intro tw:mb-6">{t("CTA.Banner.Vehicle.Intro")}</p>

              <div className="tw:grid tw:gap-2 tw:md:block tw:mt-auto">
                <button
                  onClick={() => history.push("./book")}
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:text-[1.25rem] tw:rounded-[0.5rem] tw:py-2 tw:px-4 tw:px-12 tw:md:mr-2"
                >
                  <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                    {t("Book.Your.Journey")}
                    <i className="tw:pl-2"><ArrowRightIcon color="#4A4A4A" size={24} />
                    </i>
                  </div>
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
      {/* <!-- section 9, banner, end --> */}


    </FrontLayout>
  );
};

export default Gads;
